import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './scss/SkeletonListView.scss';

const SkeletonRow = () => (
  <div className="skeleton-list-row">
    <Skeleton circle height={18} width={18} />
    <Skeleton height={14} width={180 + Math.random() * 100} style={{ borderRadius: 4 }} />
    <div className="skeleton-list-row-cols">
      <Skeleton circle height={24} width={24} />
      <Skeleton height={14} width={60} style={{ borderRadius: 4 }} />
      <Skeleton height={14} width={40} style={{ borderRadius: 4 }} />
      <Skeleton height={14} width={70} style={{ borderRadius: 4 }} />
      <Skeleton height={14} width={50} style={{ borderRadius: 4 }} />
    </div>
  </div>
);

const SkeletonGroup = ({ rowCount }) => (
  <div className="skeleton-list-group">
    <div className="skeleton-list-group-header">
      <Skeleton height={10} width={10} style={{ borderRadius: 3 }} />
      <Skeleton height={14} width={120 + Math.random() * 60} style={{ borderRadius: 4 }} />
      <Skeleton height={18} width={28} style={{ borderRadius: 10 }} />
    </div>
    {[...Array(rowCount)].map((_, i) => (
      <SkeletonRow key={i} />
    ))}
  </div>
);

const SkeletonListView = () => (
  <div className="skeleton-list-view">
    {/* Column header */}
    <div className="skeleton-list-column-header">
      <Skeleton height={12} width={60} style={{ borderRadius: 4 }} />
      <Skeleton height={12} width={55} style={{ borderRadius: 4 }} />
      <Skeleton height={12} width={55} style={{ borderRadius: 4 }} />
      <Skeleton height={12} width={50} style={{ borderRadius: 4 }} />
      <Skeleton height={12} width={45} style={{ borderRadius: 4 }} />
      <Skeleton height={12} width={60} style={{ borderRadius: 4 }} />
    </div>

    {/* Groups */}
    <SkeletonGroup rowCount={4} />
    <SkeletonGroup rowCount={3} />
    <SkeletonGroup rowCount={2} />
  </div>
);

export default SkeletonListView;
